import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.js"

fetch('./db.json')
.then(resDb=>resDb.json())
.then(res2Db=>{
                //'funzione', param
    store.commit('caricaDb',res2Db);
}).catch(err=>{
    console.log('Db not found, using defaults.', err.stack);
}).finally(() => {
    // new Vue({
    //     router,
    //     store,
    //     render: h => h(App),
    // }).$mount('#app');
    createApp(App).use(store).use(router).mount('#app') 
})
